import { render, staticRenderFns } from "./detail_price_table.vue?vue&type=template&id=79775168&scoped=true"
import script from "./detail_price_table.vue?vue&type=script&lang=js"
export * from "./detail_price_table.vue?vue&type=script&lang=js"
import style0 from "./detail_price_table.vue?vue&type=style&index=0&id=79775168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79775168",
  null
  
)

export default component.exports